export default ({ request }) => ({
    masterFabricAttributesDetailApi(data = {}) {
        return request({
            url: '/digitalCenter/master/fabric/attributes/detail',
            method: 'post',
            data
        })
    },
    masterFabricAttributesListApi(data = {}) {
        return request({
            url: '/digitalCenter/master/fabric/attributes/list',
            method: 'post',
            data
        })
    },
    masterFabricAttributesSaveApi(data = {}) {
        return request({
            url: '/digitalCenter/master/fabric/attributes/save',
            method: 'post',
            data
        })
    },
    masterFabricAttributesUpdateStatusApi(data = {}) {
        return request({
            url: '/digitalCenter/master/fabric/attributes/updateStatus',
            method: 'post',
            data
        })
    },
    masterFabricAttributes_attributesSelect(data = {}) {
        return request({
            url: '/digitalCenter/master/fabric/attributes/attributesSelect',
            method: 'post',
            data
        })
    },
    masterTargetCustomer_attributesSelect(data = {}) {
        return request({
            url: '/digitalCenter/common/dict/customer',
            method: 'post',
            data
        })
    },
})